module.exports = __webpack_public_path__ + "static/media/applogo.15722385.png";